import React from 'react';
import { Form, Button } from 'react-bootstrap';

interface BlogTitlesProps {
  titles: string[];
  selectedTitle: string | null;
  loading: boolean;
  onTitleSelect: (title: string) => void;
  onGeneratePost: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const BlogTitles: React.FC<BlogTitlesProps> = ({
  titles,
  selectedTitle,
  loading,
  onTitleSelect,
  onGeneratePost
}) => (
  <div
    className="mt-4 p-4 border rounded bg-white"
    style={{
      backgroundColor: "#fff",
      overflowX: "hidden", // Prevent horizontal overflow
      boxSizing: "border-box", // Include padding in width
    }}
  >
    <h5 className="fw-bold">Select a title:</h5>
    {titles.map((title, index) => (
      <Form.Check
        key={index}
        type="radio"
        id={`title-${index}`}
        label={title}
        checked={selectedTitle === title}
        onChange={() => onTitleSelect(title)}
        style={{ marginBottom: "10px", wordBreak: "break-word" }} // Prevent text overflow
      />
    ))}
    <Button
      variant="warning"
      onClick={onGeneratePost}
      disabled={loading || !selectedTitle}
      style={{
        backgroundColor: "#8CC540",
        borderColor: "#8CC540",
        color: "white",
        height: "38px",
        width: "100%", // Full-width button on mobile
      }}
      className="w-100 w-sm-auto" // Responsive button width
    >
      {loading ? "Creating Post..." : "✨ Generate Post"}
    </Button>
  </div>
);